import { path } from "../../../config";
import { store } from "../../../redux/store";
import fetchServer from "../../fetchServer";


export default async function updateGDSCurrency(id,data) {
  var result = {return: 0,msg: 'Failed Updating GDS Exchange',data: {}}

  let token = store.getState().user.userData.accessToken;

  await fetchServer({method: "PATCH",url: path.api+`/currency-exchanges/`+id,data,
    headers: {Authorization: `Bearer ${token}`}  
  })
  .then((res) => {
    console.log(" => ",{...res})
    if(res) {
      if(res?.data?.success) {
        result = {return: 1,msg: "Successfull",data: res.data.data};
      } else if(res.error) result['msg'] = res.error?.message;
    } 
  })
  .catch((err) => {
    console.log("Network Error: ",err);
  })

  return result;
}